"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.companyGetListApi = companyGetListApi;
exports.getLogisticsInfoApi = getLogisticsInfoApi;
exports.maintenanceOrderExcelApi = maintenanceOrderExcelApi;
exports.orderDeleteApi = orderDeleteApi;
exports.orderDetailApi = orderDetailApi;
exports.orderGoodsRefundApi = orderGoodsRefundApi;
exports.orderInvoiceListApi = orderInvoiceListApi;
exports.orderListApi = orderListApi;
exports.orderListApiByRecharge = orderListApiByRecharge;
exports.orderLogApi = orderLogApi;
exports.orderMarkApi = orderMarkApi;
exports.orderPrint = orderPrint;
exports.orderProDetailApi = orderProDetailApi;
exports.orderRefundApi = orderRefundApi;
exports.orderRefuseApi = orderRefuseApi;
exports.orderSendApi = orderSendApi;
exports.orderSendApiByRetailer = orderSendApiByRetailer;
exports.orderStatisticsApi = orderStatisticsApi;
exports.orderStatusNumApi = orderStatusNumApi;
exports.orderStatusNumApiByVirtual = orderStatusNumApiByVirtual;
exports.orderTimeApi = orderTimeApi;
exports.orderVerifyApi = orderVerifyApi;
exports.orderVerifyBatchApi = orderVerifyBatchApi;
exports.orderVerifyUploadApi = orderVerifyUploadApi;
exports.refundListApi = refundListApi;
exports.refundMarkApi = refundMarkApi;
exports.refundOrderDetailApi = refundOrderDetailApi;
exports.refundStatusNumApi = refundStatusNumApi;
exports.refuseOrderApi = refuseOrderApi;
exports.reportBatchApi = reportBatchApi;
exports.sheetInfoApi = sheetInfoApi;
exports.statisticsDataApi = statisticsDataApi;
exports.supplierOrderExcelApi = supplierOrderExcelApi;
exports.updatePriceApi = updatePriceApi;
exports.videoSendApi = videoSendApi;
exports.writeUpdateApi = writeUpdateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 订单 列表
 * @param prams
 */
function orderListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/order/list',
    method: 'get',
    params: params
  });
}

/**
 * 订单 列表 获取各状态数量
 * @param params
 */
function orderStatusNumApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/order/status/num',
    method: 'get',
    params: params
  });
}

/**
 * 订单 删除
 * @param params
 */
function orderDeleteApi(orderNo) {
  return (0, _request.default)({
    url: "/admin/merchant/order/delete/".concat(orderNo),
    method: 'post'
  });
}

/**
 * 订单 记录
 * @param prams
 */
function orderLogApi(params) {
  return (0, _request.default)({
    url: '/admin/store/order/status/list',
    method: 'get',
    params: params
  });
}

/**
 * 订单 详情
 * @param prams
 */
function orderDetailApi(orderNo) {
  return (0, _request.default)({
    url: "/admin/merchant/order/info/".concat(orderNo),
    method: 'get'
  });
}

/**
 * 订单 备注
 * @param prams
 */
function orderMarkApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/order/mark',
    method: 'post',
    data: data
  });
}

/**
 * 订单 发货
 * @param prams
 */
function orderSendApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/order/send',
    method: 'post',
    data: data
  });
}

/**
 * 订单 发货
 * @param prams
 */
function orderSendApiByRetailer(data) {
  return (0, _request.default)({
    url: '/admin/retailer/order/goods/send',
    method: 'post',
    data: data
  });
}
/**
 * 订单 拒绝退款
 * @param prams
 */
function orderRefuseApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/refund/order/refund/refuse',
    method: 'get',
    params: params
  });
}

/**
 * 订单 立即退款
 * @param prams
 */
function orderRefundApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/refund/order/refund',
    method: 'get',
    params: params
  });
}
function orderGoodsRefundApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/refund/order/refund/goods',
    method: 'post',
    data: data
  });
}

/**
 * 订单 统计 头部数据
 */
function orderStatisticsApi() {
  return (0, _request.default)({
    url: "/admin/store/order/statistics",
    method: 'get'
  });
}

/**
 * 核销订单 月列表数据
 */
function statisticsDataApi(params) {
  return (0, _request.default)({
    url: "/admin/store/order/statisticsData",
    method: 'get',
    params: params
  });
}

/**
 * 一键改价
 */
function updatePriceApi(data) {
  return (0, _request.default)({
    url: "admin/store/order/update/price",
    method: 'post',
    data: data
  });
}

/**
 *订单统计详情
 */
function orderTimeApi(params) {
  return (0, _request.default)({
    url: "/admin/store/order/time",
    method: 'get',
    params: params
  });
}

/**
 *面单默认配置信息
 */
function sheetInfoApi() {
  return (0, _request.default)({
    url: "/admin/store/order/sheet/info",
    method: 'get'
  });
}

/**
 *面单默认配置信息
 */
function getLogisticsInfoApi(invoiceId) {
  return (0, _request.default)({
    url: "/admin/merchant/order/get/".concat(invoiceId, "/logistics/info"),
    method: 'get'
  });
}

/**
 *视频号物流公司
 */
function companyGetListApi() {
  return (0, _request.default)({
    url: "/admin/pay/component/delivery/company/get/list",
    method: 'get'
  });
}

/**
 *视频号物流公司
 */
function videoSendApi(data) {
  return (0, _request.default)({
    url: "/admin/store/order/video/send",
    method: 'post',
    data: data
  });
}

/**
 *打印小票
 */
function orderPrint(id) {
  return (0, _request.default)({
    url: "/admin/yly/print/".concat(id),
    method: 'get'
  });
}

/**
 *退款列表
 */
function refundListApi(params) {
  return (0, _request.default)({
    url: "/admin/merchant/refund/order/list",
    method: 'get',
    params: params
  });
}

/**
 *退商户备注退款订单
 */
function refundMarkApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/refund/order/mark",
    method: 'post',
    data: data
  });
}

/**
 *获取退款订单各状态数量
 */
function refundStatusNumApi(params) {
  return (0, _request.default)({
    url: "/admin/merchant/refund/order/status/num",
    method: 'GET',
    params: params
  });
}

/**
 * 订单 核销订单
 * @param data
 */
function writeUpdateApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/order/verification",
    method: 'post',
    data: data
  });
}

/**
 * 订单细节详情列表（发货使用）
 * @param orderNo 订单号
 */
function orderProDetailApi(orderNo) {
  return (0, _request.default)({
    url: "/admin/merchant/order/".concat(orderNo, "/detail/list"),
    method: 'get'
  });
}

/**
 * 获取订单发货单列表
 * @param orderNo 订单号
 */
function orderInvoiceListApi(orderNo) {
  return (0, _request.default)({
    url: "/admin/merchant/order/".concat(orderNo, "/invoice/list"),
    method: 'get'
  });
}

/**
 * 订单 列表 获取各状态数量 - 虚拟品统计
 * @param params
 */
function orderStatusNumApiByVirtual(params) {
  return (0, _request.default)({
    url: '/admin/merchant/order/recharge/status/num',
    method: 'get',
    params: params
  });
}

/**
 * 订单 列表 - 充值类订单列表
 * @param prams
 */
function orderListApiByRecharge(params) {
  return (0, _request.default)({
    url: '/admin/merchant/order/recharge/list',
    method: 'get',
    params: params
  });
}

/**
 * 平台端退款订单详情
 * @param refundOrderNo 订单号
 */
function refundOrderDetailApi(refundOrderNo) {
  return (0, _request.default)({
    url: "/admin/merchant/refund/order/detail/".concat(refundOrderNo),
    method: 'get'
  });
}

/**
 * 养车服务订单导出API
 * @param params 对象
 */
function maintenanceOrderExcelApi(params) {
  return (0, _request.default)({
    url: "/admin/merchant/export/maintenance/order/excel",
    method: 'get',
    params: params
  });
}
function supplierOrderExcelApi(params) {
  return (0, _request.default)({
    url: "/admin/merchant/export/supplier/order/excel",
    method: 'get',
    params: params
  });
}
function refuseOrderApi(data) {
  return (0, _request.default)({
    url: "/admin/merchant/order/refuse",
    method: 'post',
    data: data
  });
}
/**
 * h5订单核销
 */
function orderVerifyApi(data) {
  return (0, _request.default)({
    url: "/merchant/virtual/order/verify",
    method: 'post',
    data: data
  });
}
/**
 * 订单批量核销
 */
function orderVerifyBatchApi(data) {
  return (0, _request.default)({
    url: "/merchant/virtual/order/verify/batch",
    method: 'post',
    data: data
  });
}

/**
 * 订单上传图片
 */
function orderVerifyUploadApi(data) {
  return (0, _request.default)({
    url: "/merchant/virtual/order/verify/upload",
    method: 'post',
    data: data
  });
}

/**
 * 批量生成检测报告
 */
function reportBatchApi(data) {
  return (0, _request.default)({
    url: "/merchant/virtual/order/verify/reportBatch",
    method: 'post',
    data: data
  });
}